import get from 'lodash/get'
import isEmpty from 'lodash/isEmpty'
import uuid from 'uuid/v1'

import { warn } from 'utils'
import { rectifyTrade } from 'utils/trade'

export const COOKIE_NAME = 'magic-link-context'

// magic link cookie getter to hydrate customer tag from context
export const getCookie = key => {
    let cookie = document.cookie,
      output = cookie.split(/\s*;\s*/).reduce((ret, c) => {
        let pair = c.split(/\s*=\s*/)

        return {
          ...ret,
          [pair[0]]: pair
            .splice(1)
            .join('=')
            .replaceAll('+', '%20'), // TODO safe?
        }
      }, {})

    return decodeURIComponent(output[key])
  },
  convertMagicCookie = (magicCookie, useSqueezeJacketReplacement) => {
    let {
        firstName,
        lastName,
        phoneNumber,
        emailAddress,
        postalCode,
        zipCode,
        source,
        campaign,
        scenarioType,
        scenarioId,
        overrideLocalStorage,
        tradeParams = {},
        theme,
        rooftopName,
      } = magicCookie,
      magicCustomer

    //TODO: FSCRUM-1491 -- This behavior is only needed while the squeeze jacket
    //is around. The id has to be cleared for the squeeze jacket to work
    //properly for invites.
    if  (!useSqueezeJacketReplacement || !scenarioId){
      // null the trade id on decode to force reselect of trim/options
      //console.log("MAGIC-COOKIE-TRADE!!!", "DELETING TRADEPENDING ID", rooftopName, tradeParams.id, tradeParams.tradePendingId, useSqueezeJacketReplacement, scenarioId)
      delete tradeParams.id
      delete tradeParams.tradePendingId
    }else{
      //console.log("MAGIC-COOKIE-TRADE!!!", "NOT DELETING TRADEPENDING ID", rooftopName, tradeParams.id, tradeParams.tradePendingId, useSqueezeJacketReplacement)
    }

    magicCustomer = !isEmpty(magicCookie)
      ? {
          sessionId: magicCookie.deviceId || uuid(),
          firstName,
          lastName,
          source,
          campaign,
          phone: phoneNumber,
          email: get((emailAddress || '').split(';'), 0), // TODO sometimes there's a semicolon in the magic link
          zipCode: postalCode || zipCode, // this is to uuuu
          vehicleId: get(magicCookie, 'decodedInventoryParams.vehicleId'),
          trades: !isEmpty(tradeParams)
          ? [rectifyTrade(tradeParams, { confirmed: tradeParams.confirmed })]
            : [],
          theme,
          rooftopName,
        overrideLocalStorage: overrideLocalStorage ? overrideLocalStorage : false,
        scenarioType: scenarioType,
        scenarioId: scenarioId,
        }
      : {}

    return magicCustomer
  },
  getMagicCustomer = (useSqueezeJacketReplacment) => {
    let cookieData = {}

    try {
      cookieData = JSON.parse(getCookie(COOKIE_NAME))
    } catch (e) {
      warn('Failed to get magic customer')
    }
    return convertMagicCookie(cookieData, useSqueezeJacketReplacment)
  }

window.getMagicCustomer = getMagicCustomer
